<template>
  <el-popover
    placement="right"
    trigger="manual"
    ref="popover"
    v-model="visible">
    <el-checkbox-group v-model="currentValue" class="checkbox-group-popover">
      <el-checkbox v-for="item in dataset" :key="item.role_name" :label="item.id">{{item.role_name}}</el-checkbox>
    </el-checkbox-group>
    <template #reference>
      <el-tooltip effect="dark" content="显示权限" placement="bottom" @click.native="togglePopover">
        <i class="el-icon-key tableIconHover"></i>
      </el-tooltip>
    </template>
  </el-popover>
</template>
<script>
import api from "@/services/api/role/role"
import bus from '@/bus'
export default {
  props: ['value'],
  data() {
    return {
      dataset: [],
      visible: false
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val || [])
      }
    }
  },
  created() {
    this.init()
    bus.$on('closePopover', this.closePopover)
  },
  mounted() {
    document.addEventListener('click', this.bodyCloseMenus);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.bodyCloseMenus);
    bus.$off('closePopover')
  },
  methods: {
    async init() {
      let result = await api.getRoleList({ page: 1, number: 9999 })
      this.dataset = result?.data
      this.currentValue = result?.data.map(res => res.id)
    },
    togglePopover() {
      bus.$emit('closePopover')
      this.$refs.popover && (this.visible = !this.visible)
    },
    bodyCloseMenus(e) {
      if (this.$refs.popover && this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        if (this.visible == true) {
          this.visible = false
        }
      }
    },
    closePopover() {
      this.visible = false
    }
  },
}
</script>
<style lang="scss">
.checkbox-group-popover {
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-bottom: 0;
  >* {
    margin-bottom: 16px;
  }
}
</style>
